import { Injectable } from '@angular/core';
import { AbstractControl, ValidatorFn } from '@angular/forms';
import { ErrorMessageHelper } from '../utilities/error-message.i18n.helper';
import { passwordValidator, strictPasswordValidator } from './password.validator';

@Injectable({ providedIn: 'root' })
export class PasswordI18nValidator {
    constructor(public errorMessageHelper: ErrorMessageHelper) {}

    public password(): ValidatorFn {
        return (control: AbstractControl): { password: any } | null => {
            const validatorResult = passwordValidator(control);
            if (validatorResult?.password?.message) {
                validatorResult.password.message = this.errorMessageHelper.password;
            }
            return validatorResult;
        };
    }

    public strictPassword(): ValidatorFn {
        return (control: AbstractControl): { password: any } | null => {
            const validatorResult = strictPasswordValidator(control);
            if (validatorResult?.password?.message) {
                validatorResult.password.message = this.errorMessageHelper.passwordRequirementsNotMet;
            }
            return validatorResult;
        };
    }
}
